import { useState } from 'preact/hooks';
import { Link, useLocation } from 'wouter-preact';
import { EndpointTree } from './EndpointTree';
import { ChangelogModal } from './ChangelogModal';
import { sidebarOpen } from '../store/global';
import pkg from '../../package.json';

const NAV = [
  { href: '/chat', label: 'Chat', icon: 'chat-circle' },
  { href: '/team-map', label: 'Team map', icon: 'tree-structure' },
  { href: '/knowledge', label: 'Conhecimento', icon: 'book-open' },
  { href: '/memories', label: 'Memórias', icon: 'brain' },
  { href: '/schedules', label: 'Agendamentos', icon: 'clock' },
  { href: '/approvals', label: 'Aprovações', icon: 'shield-check' },
  { href: '/eval', label: 'Avaliações', icon: 'graduation-cap' },
  { href: '/models', label: 'Modelos', icon: 'cpu' },
  { href: '/settings', label: 'Configurações', icon: 'gear' },
] as const;

export function Sidebar() {
  const [location] = useLocation();
  const [changelogOpen, setChangelogOpen] = useState(false);
  const current = location === '/' ? '/chat' : location;

  // Em mobile (< md): drawer fixed que aparece via translate.
  // Em desktop (≥ md): coluna estática (sempre visível).
  // Touch target dos itens é maior em mobile (py-2.5 ≈ 44px com gap).
  const drawerOpen = sidebarOpen.value;
  const close = () => (sidebarOpen.value = false);

  return (
    <>
      <aside
        class={`fixed md:relative inset-y-0 left-0 z-40 w-72 md:w-64 border-r border-border bg-sidebar text-sidebar-foreground flex flex-col shrink-0 transform transition-transform duration-200 ease-out md:transform-none ${
          drawerOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
        }`}
      >
        <div class="h-14 flex items-center gap-2 px-4 border-b border-sidebar-border">
          <img src="/blips-logo.png" alt="blips" class="h-5 w-auto dark:invert" />
          <span class="text-muted-foreground">/</span>
          <span class="text-muted-foreground font-medium text-sm">agents</span>
          <button
            class="ml-auto -mr-2 inline-flex items-center justify-center size-8 rounded-md hover:bg-sidebar-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-sidebar-ring md:hidden"
            onClick={close}
            aria-label="Fechar menu"
          >
            <i class="ph ph-x text-base" />
          </button>
        </div>

        <div class="border-b border-sidebar-border py-1.5">
          <EndpointTree />
        </div>

        <nav class="flex-1 overflow-y-auto py-2">
          <div class="px-2 py-1">
            <span class="text-[11px] uppercase tracking-wider text-muted-foreground font-medium block px-2 py-1">
              Navegação
            </span>
          </div>
          {NAV.map(({ href, label, icon }) => {
            const active = current === href || (href === '/chat' && current === '/');
            return (
              <Link
                key={href}
                href={href}
                onClick={close}
                class={`flex items-center gap-2.5 px-4 py-2.5 md:py-1.5 text-sm rounded-sm hover:bg-sidebar-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-sidebar-ring ${
                  active
                    ? 'font-medium text-sidebar-accent-foreground bg-sidebar-accent'
                    : 'text-sidebar-foreground'
                }`}
              >
                <i class={`${active ? 'ph-bold' : 'ph'} ph-${icon} text-sm shrink-0`} />
                <span>{label}</span>
                {active && <span class="ml-auto size-1.5 rounded-full bg-primary" />}
              </Link>
            );
          })}
        </nav>

        <div class="p-2 border-t border-sidebar-border">
          <button
            class="w-full h-8 px-2 rounded-md text-xs text-muted-foreground font-mono tabular-nums flex items-center justify-between hover:bg-sidebar-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-sidebar-ring"
            onClick={() => setChangelogOpen(true)}
            title="Ver changelog"
          >
            <span>v{pkg.version}</span>
            <span class="text-[10px] uppercase tracking-wider">changelog</span>
          </button>
        </div>
      </aside>

      <ChangelogModal open={changelogOpen} onClose={() => setChangelogOpen(false)} />
    </>
  );
}
